module.exports = __webpack_public_path__ + "img/7.47d0bbc5.svg";